export const SourceRequestStatusInfo = "PbhRequestStatusInfos";

export const TitleRequestStatusInfo = {
  list: "Pbh Request Status Info List",
  create: "Create Pbh Request Status Info",
  edit: "Edit Pbh Request Status Info",
};
